export default __webpack_public_path__ + "static/media/dgarts.ce27204c.png";